import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import { ConversationalAssistantRouteEnum } from '~/router/@types';

const ConversationalAssistantPage = lazy(() => import('~/pages/ConversationalAssistant'));

export const CONVERSATIONAL_ASSISTANT_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={ConversationalAssistantRouteEnum.Flagged} replace />,
  },
  {
    path: ':tab/:listingId?',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <ConversationalAssistantPage />
      </Suspense>
    ),
  },
];
